export default __webpack_public_path__ + "static/media/HowItWorks-01.07e7569d.jpg";